import React, { useState } from 'react';
import {
  DndContext,
  DragOverlay,
  closestCorners,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';

const PresetDndContext = ({ handleDragEnd, children }) => {
  const [activeDrag, setActiveDrag] = useState(null);
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 5 } })
  );

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCorners}
      onDragEnd={handleDragEnd}
      onDragStart={(e) => setActiveDrag(e.active.id)}
    >
      {children}
      <DragOverlay dropAnimation={null}>
        {activeDrag ? <div id={activeDrag} /> : null}
      </DragOverlay>
    </DndContext>
  );
};

export default PresetDndContext;
